import { Privacy } from '../../../ControlsBar/PrivacyDropdown/types'
import getPostReplyPrivacy from '../getPostReplyPrivacy'
import { PrivacyOptionsVariant } from '../../../types'
import getGroupChannelPublicPrivacyOptions from '../getGroupChannelPrivacyOptions'

type Props = {
  variant?: PrivacyOptionsVariant
}

const getPrivacyOptions = ({ variant }: Props): Privacy[] => {
  switch (variant) {
    case PrivacyOptionsVariant.Post:
      return getPostReplyPrivacy(false)
    case PrivacyOptionsVariant.Reply:
      return getPostReplyPrivacy(true)
    default:
      return getGroupChannelPublicPrivacyOptions(variant)
  }
}

export default getPrivacyOptions
